import React from 'react';

const Toolbar = () => {
    return (
        <div className="toolbar">
            <div className="container">
                <div className="row">
                    <div className="col-8">
                        <span className="toolbar-address">
                            <img src={process.env.PUBLIC_URL + '/assets/images/maker.png'} alt="make" />
                            Rua Antônio Schiavon, 290. Bairro Três Marias. Campinas-SP.
                        </span>
                    </div>
                    <div className="col-4">
                        <ul className="social-icons float-right">
                            <li><a href="#"><img src={process.env.PUBLIC_URL + '/assets/images/facebook.png'} alt="facebook" /></a></li>
                            <li><a href="#"><img src={process.env.PUBLIC_URL + '/assets/images/instagram.png'} alt="instagram" /></a></li>
                            <li><a href="#"><img src={process.env.PUBLIC_URL + '/assets/images/linkedin.png'} alt="linkedin" /></a></li>
                            <li><a href="#"><img src={process.env.PUBLIC_URL + '/assets/images/twitter.png'} alt="twitter" /></a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Toolbar;